module.exports = __webpack_public_path__ + "static/media/dashboard.3ec23f2a.svg";